import { showDialog } from '../../dialog/index';
import Logger from '../../../services/Logger';
import sdk from '../../../sdk/index';
import * as utils from '../../../shared/utils';
import l18n from '../../../shared/strings';
import Toast from '../../Toast';
import UiBlocker from '../../../services/UiBlocker';
import picsioConfig from '../../../../../../config';

function formatAdditionalData(additionalData) {
  if (Object.keys(additionalData).length) {
    const data = Object.keys(additionalData).reduce((acc, key) => `${acc}${key}: ${additionalData[key]}\n`, '');
    return `\n\n[Additional data]:\n${data}`;
  }
  return '';
}

const handleSuggestImprovement = (title, text, placeholder, additionalData = {}, initiationLocation = '') => {
  Logger.log('User', 'SuggestImproveIconClicked', { initiation_location: initiationLocation || (window && window.location.pathname) });
  const savedText = utils.LocalStorage.get('picsio.suggestImprovementText') || '';
  showDialog({
    title: title || l18n.DIALOGS.SUGGEST_IMPROVEMENT.TITLE,
    text: text || l18n.DIALOGS.SUGGEST_IMPROVEMENT.TEXT,
    textarea: {
      placeholder: placeholder || (picsioConfig.isPim ? l18n.DIALOGS.SUGGEST_IMPROVEMENT.PLACEHOLDER_TORIUT : l18n.DIALOGS.SUGGEST_IMPROVEMENT.PLACEHOLDER),
      value: savedText,
      onChange: (e, value) => {
        utils.LocalStorage.set('picsio.suggestImprovementText', value);
      },
    },
    textBtnOk: l18n.DIALOGS.SUGGEST_IMPROVEMENT.BTN_OK,
    textBtnCancel: l18n.DIALOGS.SUGGEST_IMPROVEMENT.BTN_CANCEL,
    onOk: async ({ textarea }) => {
      if (textarea) {
        try {
          UiBlocker.block();
          await sdk.axiosInstance.post('/contact/improvement', { text: textarea + formatAdditionalData(additionalData) });
          Logger.log('User', 'SuggestImproveModalSentClicked', {
            text: textarea + formatAdditionalData(additionalData),
            initiation_location: initiationLocation || (window && window.location.pathname),
          });
          utils.LocalStorage.remove('picsio.suggestImprovementText');
          Toast(l18n.TOAST.SUCCESS_SEND_SUGGESTION_FOR_IMPROVEMENT, {
            autoClose: false,
            type: 'success',
          });
        } catch (error) {
          Logger.error(new Error('Cannot send suggestion for improvement'), { error }, [
            'SuggestImprovementDialogSend',
            { errorMessage: (error && error.message) || 'NoMessage' },
          ]);
          Toast(l18n.TOAST.ERROR_SEND_SUGGESTION_FOR_IMPROVEMENT, {
            autoClose: false,
            type: 'error',
          });
        } finally {
          UiBlocker.unblock();
        }
      }
    },
    onCancel: () => {
      Logger.log('User', 'SuggestImproveModalClosed', { initiation_location: initiationLocation || (window && window.location.pathname) });
    },
  });
  Logger.log('User', 'SuggestImproveModalShown', { initiation_location: initiationLocation || (window && window.location.pathname) });
};

export default handleSuggestImprovement;
